import validateYupSchema from 'common/utils/validateYupSchema';
import { adCampaignFormValidationSchema } from 'modules/campaigns/ad-campaign/utils/adCampaignFormValidationSchema';
import { AdCampaignFormValues } from 'modules/campaigns/types';

export enum FormValidationError {
  INVALID_TERMS_AND_CONDITIONS,
  INVALID_END_DATE,
}

export const validateForm = ({
  values,
  adsFreeTrialConfig,
}: {
  values: AdCampaignFormValues;
  adsFreeTrialConfig?: {
    formattedWeeklyBudgetWithCurrency: string;
    freeTrialDaysMinimum: number;
    freeTrialPlusPaidCampaignMinimumDays: number;
    durationWeeks: number;
  };
}): Record<FormValidationError, boolean> => {
  const errors: Partial<Record<keyof AdCampaignFormValues, string>> =
    validateYupSchema(adCampaignFormValidationSchema({ adsFreeTrialConfig }))(values) || {};

  return {
    [FormValidationError.INVALID_TERMS_AND_CONDITIONS]: !values.agreementTermsAndConditions,
    [FormValidationError.INVALID_END_DATE]: !!errors?.endDate,
  };
};
